<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    this.resize(document.getElementById('app').offsetWidth)
    window.addEventListener('resize', e => {
      this.resize(e.currentTarget.innerWidth)
    })
  },
  methods: {
    resize (width) {
      let top = (document.getElementsByTagName('body')[0].offsetHeight - 667) / 2
      if (width > 500) {
        document.getElementById('app').style.width = '375px'
        document.getElementById('app').style.height = '667px'
        document.getElementById('app').style.margin = `${top + 'px'} auto`
        document.getElementsByTagName('body')[0].style.background = '#999'
        setTimeout(() => {
          document.getElementsByTagName('html')[0].style.fontSize = '37.5px'
        }, 300)
      } else {
        document.getElementById('app').style.width = '100%'
        document.getElementById('app').style.height = '100%'
        document.getElementById('app').style.margin = '0'
        document.getElementsByTagName('body')[0].style.backgroundColor = '#fff'
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/reset.scss';
@import './static/font/font.scss';
html,
body {
  height: 100%;
  overflow: hidden;
  font-family: "方正兰亭黑";
}
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: relative;
  background: #000;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/App.vue